<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-15 15:01:00
 * @FilePath: /privacy-web/src/views/PrivacyPolicy/index.vue
-->
<template>
  <div class="privacy-policy">
    <!-- 贝壳隐私政策 start -->
    <Policy-content></Policy-content>
    <!-- 贝壳隐私政策 end -->
  </div>
</template>

<script>
  import PolicyContent from './PolicyContent';
  export default {
    // 隐私政策入口
    name: 'privacyPolicy-index',
    components: {
      PolicyContent
    }
  };
</script>
